import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';

/**
 * Emitted when a member's agent profile is saved (own-profile maintenance in
 * IMM-273; Owner/Admin edits in IMM-221.3 reuse the same leaf). Ids only on the
 * payload per ADR 0015 §PII — the changed field values are not carried.
 */
export const MemberProfileUpdatedPayloadSchema = z.object({
  memberId: z.uuid(),
  workspaceId: z.uuid(),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});

export type MemberProfileUpdatedPayload = z.infer<typeof MemberProfileUpdatedPayloadSchema>;
